/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterTree } from './FilterTree';
import { FilterTreeFromJSON, FilterTreeFromJSONTyped, FilterTreeToJSON } from './FilterTree';

/**
 *
 * @export
 * @interface FilterTreeResults
 */
export interface FilterTreeResults {
  /**
   *
   * @type {Array<FilterTree>}
   * @memberof FilterTreeResults
   */
  results: Array<FilterTree>;
}

/**
 * Check if a given object implements the FilterTreeResults interface.
 */
export function instanceOfFilterTreeResults(value: object): value is FilterTreeResults {
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function FilterTreeResultsFromJSON(json: any): FilterTreeResults {
  return FilterTreeResultsFromJSONTyped(json, false);
}

export function FilterTreeResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterTreeResults {
  if (json == null) {
    return json;
  }
  return {
    results: (json['results'] as Array<any>).map(FilterTreeFromJSON),
  };
}

export function FilterTreeResultsToJSON(value?: FilterTreeResults | null): any {
  if (value == null) {
    return value;
  }
  return {
    results: (value['results'] as Array<any>).map(FilterTreeToJSON),
  };
}
